import { requestPublicJson } from './api.js';

export function getSharedMailerLandingPage() {
  return requestPublicJson('/api/public/mailers/landing-page');
}

export function getMailerTrackingLandingPage() {
  return requestPublicJson('/api/public/mailers/tracking-page');
}

export function getSpotlightDealLandingPage() {
  return requestPublicJson('/api/public/mailers/spotlight-deal-page');
}

export function submitSharedMailerLead(payload) {
  return requestPublicJson('/api/public/mailers/landing-page/leads', {
    method: 'POST',
    body: payload,
  });
}

export function autocompleteSharedMailerBusinesses(input, sessionToken) {
  return requestPublicJson('/api/public/mailers/landing-page/businesses/autocomplete', {
    method: 'POST',
    body: { input, sessionToken },
  });
}
